import {
    AUTH0_RETURN_TO_SESSION_KEY,
    getAccessToken,
    isAccessTokenAuth0,
    SESSION_EVALUATED_DOM_EVENT,
} from '@libs/core';

export const AUTH0_CART_MERGE_COMPLETE_EVENT = 'ecom:auth0-cart-merge-complete';

const AUTH0_CART_MERGE_COOKIE_TIMEOUT_MS = 8000;
const AUTH0_CART_MERGE_COMPLETE_TIMEOUT_MS = 10000;

let auth0CartMergeSignaled = false;

function hasAuth0AccessTokenCookie(): boolean {
    return Boolean(isAccessTokenAuth0() && getAccessToken());
}

function hasAuth0CartMergeSignaled(): boolean {
    return auth0CartMergeSignaled;
}

function waitForWindowEvent(eventName: string, timeoutMs: number, isAlreadyDone?: () => boolean): Promise<void> {
    return new Promise(resolve => {
        let settled = false;
        const timeoutId = globalThis.setTimeout(finish, timeoutMs);

        function finish() {
            if (settled) {
                return;
            }
            settled = true;
            globalThis.clearTimeout(timeoutId);
            globalThis.window?.removeEventListener(eventName, onEvent);
            resolve();
        }

        function onEvent() {
            if (!isAlreadyDone || isAlreadyDone()) {
                finish();
            }
        }

        globalThis.window?.addEventListener(eventName, onEvent);
        if (isAlreadyDone?.()) {
            finish();
        }
    });
}

export function persistAuth0ReturnTo(returnTo: string) {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    sessionStorage.setItem(AUTH0_RETURN_TO_SESSION_KEY, returnTo);
}

export function readAuth0ReturnTo(): string {
    if (typeof sessionStorage === 'undefined') {
        return '';
    }
    return sessionStorage.getItem(AUTH0_RETURN_TO_SESSION_KEY) ?? '';
}

export function signalAuth0CartMergeDone() {
    auth0CartMergeSignaled = true;
    globalThis.window?.dispatchEvent(new CustomEvent(AUTH0_CART_MERGE_COMPLETE_EVENT));
}

export function resetAuth0CartMergeSignal() {
    auth0CartMergeSignaled = false;
}

export function waitForAuth0AccessTokenCookie(): Promise<void> {
    return waitForWindowEvent(
        SESSION_EVALUATED_DOM_EVENT,
        AUTH0_CART_MERGE_COOKIE_TIMEOUT_MS,
        hasAuth0AccessTokenCookie
    );
}

export function waitForAuth0CartMerge(): Promise<void> {
    return waitForWindowEvent(
        AUTH0_CART_MERGE_COMPLETE_EVENT,
        AUTH0_CART_MERGE_COMPLETE_TIMEOUT_MS,
        hasAuth0CartMergeSignaled
    );
}
